import React from 'react';
import {
	Dialog, DialogTitle, DialogContent, DialogActions,
	Box, Typography, Button, IconButton, Stack, Grid
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { theme } from '../../../styles/theme';

const FeatureDialog = ({ feature, open, onClose }) => {
	if (!feature) return null;

	return (
		<Dialog
			open={open}
			onClose={onClose}
			maxWidth="md"
			fullWidth
			PaperProps={{
				sx: {
					bgcolor: '#0a0a0a',
					border: `1px solid ${theme.colors.borderPrimary}`,
					borderRadius: 2
				}
			}}
		>
			<DialogTitle sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'space-between',
				borderBottom: '1px solid rgba(220,38,38,0.2)',
				color: '#fff',
				fontWeight: 700
			}}>
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
					{feature.icon}
					<Box>
						<Typography variant="overline" sx={{ color: theme.colors.primary, letterSpacing: 1 }}>
							{feature.tag}
						</Typography>
						<Typography variant="h5" sx={{ fontWeight: 800, color: '#fff' }}>
							{feature.title}
						</Typography>
					</Box>
				</Box>
				<IconButton onClick={onClose} sx={{ color: theme.colors.textSecondary, '&:hover': { color: theme.colors.primary } }}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent sx={{ py: 4 }}>
				<Stack spacing={3}>
					<Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.78)', lineHeight: 1.8 }}>
						{feature.longDescription || feature.description}
					</Typography>
					{feature.subFeatures && feature.subFeatures.length > 0 && (
						<Box>
							<Typography variant="subtitle1" sx={{ fontWeight: 700, color: theme.colors.primary, mb: 1 }}>
								Key capabilities
							</Typography>
							<Stack spacing={1.5}>
								{feature.subFeatures.map((item) => (
									<Box key={item.title} sx={{
										p: 2,
										border: `1px solid ${theme.colors.borderPrimary}`,
										borderRadius: 2,
										bgcolor: 'rgba(255,255,255,0.04)'
									}}>
										<Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#fff' }}>
											{item.title}
										</Typography>
										<Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.75)', lineHeight: 1.6 }}>
											{item.details}
										</Typography>
									</Box>
								))}
							</Stack>
						</Box>
					)}
					<Grid container spacing={2} sx={{ mt: 2 }}>
						{feature.proofPoints?.map((proof) => (
							<Grid item xs={12} sm={4} key={proof.label}>
								<Box sx={{
									p: 2,
									border: `1px solid ${theme.colors.borderPrimary}`,
									borderRadius: 2,
									bgcolor: 'rgba(255,255,255,0.02)'
								}}>
									<Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.55)', textTransform: 'uppercase', letterSpacing: 0.6 }}>
										{proof.label}
									</Typography>
									<Typography variant="body2" sx={{ color: '#fff', fontWeight: 600 }}>
										{proof.value}
									</Typography>
								</Box>
							</Grid>
						))}
					</Grid>
				</Stack>
			</DialogContent>
			<DialogActions sx={{ borderTop: '1px solid rgba(220,38,38,0.15)', px: 3, py: 2 }}>
				<Button onClick={onClose} sx={{ color: theme.colors.primary }}>
					Close
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default FeatureDialog;
